import React, { useState } from 'react'
import Layout from '../../layout'


import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CustomModal from '../../components/layout_components/CustomModal/_index';
import AssessmentGrid from '../../components/pages_components/test_library/AssessmentGrid';


import assessmentsLibrary from './data';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `wrapped-tab-${index}`,
        "aria-controls": `wrapped-tabpanel-${index}`
    };
}

const styles = {
    marginRight: "1rem",
    backgroundColor: "transparent" /* Green */,
    border: "2px solid #333333",
    borderRadius: "5px",
    color: "#333333",
    padding: "15px 32px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    textTransform: "capitalize",
    "&.Mui-selected": {
        backgroundColor: "#333333",
        border: "none",
        color: "white",
        padding: "15px 32px",
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        fontSize: "16px"
    }
}
const styles2 = {
    marginRight: "1rem",
    backgroundColor: "transparent" /* Green */,
    color: "#333333",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    textTransform: "capitalize",
    "&.Mui-selected": {
        backgroundColor: "#333333",
        border: "none",
        color: "#ffd700",
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        fontSize: "16px"
    }
}


const TestLibrary = () => {

    const [value, setValue] = React.useState("0");
    const [value2, setValue2] = React.useState("inner0");


    const handleChange = (event, newValue) => {

        setValue(newValue);
    };
    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
    };


    const [isOpen, setIsOpen] = useState(false)

    const [modalData, setModalData] = useState({ heading: "", desc: "" })




    return (
        <Layout>
            <div className="library">
                <div className="libraryWrapper">

                    {/* page header starts */}
                    <div className="pageHeader bg-[#FFD700] p-5 md:p-10 lg:pt-10 lg:pb-5  ">
                        <div className="content w-[22rem] sm:w-[35rem] lg:w-[800px] mx-auto text-center xl:w-[1000px] 2xl:w-[1168px]">
                            <h1 className='text-xl font-bold lg:text-[2rem] lg:leading-[2.5rem] xl:text-[2.5rem] xl:leading-[3rem] 2xl:text-[48px] 2xl:leading-[55px] text-[#333333]'>Evaluate candidates for their skills, cognitive abilities, behaviors and other competencies</h1>
                            <div className='text-[14px] md:text-[14px] lg:text-[18px] xl:text-[20px] xl:leading-[46px] 2xl:text-[24px] 2xl:leading-[50px] 2xl:mt-[20px] mt-[9px]'>Check out our full range of competency frameworks below</div>
                        </div>
                    </div>
                    {/* page header ends */}

                    {/* libary starts */}

                    {/* custom Modal start */}
                    <div className="libraryWrapper mt-5">

                        <CustomModal isOpen={isOpen}
                            allData={modalData}
                            handleCloseModal={() => setIsOpen(false)}
                        />

                        {/* custom modal End */}

                        <div className="librarySwitch w-[22rem] sm:w-[40rem] sm:mt-5 lg:pt-10 lg:w-[90vw] mx-auto flex justify-around">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="wrapped label tabs example"
                                TabIndicatorProps={{ style: { backgroundColor: "#333333" } }}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                            // scrollButtons="auto"

                            >


                                {
                                    assessmentsLibrary.map((assessment, indexNum) =>
                                        <Tab
                                            key={`TabAssessment${assessment.name + indexNum}`}
                                            value={`${indexNum}`}
                                            label={assessment.name}
                                            {...a11yProps(`${indexNum}`)}
                                            sx={styles}
                                            className="2xl:w-[352px] 2xl:!mx-[20px] 2xl:!text-[18px] 2xl:!leading-[38px] !font-[650]"

                                        />
                                    )
                                }
                            </Tabs>


                        </div>

                        <div className="panels w-[20rem] bg-fixed bg-no-repeat sm:w-[40rem] lg:w-[95vw] mx-auto flex justify-center bg-test-library-pattern bg-cover">

                            {
                                assessmentsLibrary.map((assessment, indexNum) =>
                                    <TabPanel key={`TabPanelParent${assessment.name + indexNum}`} value={value} index={indexNum.toString()}>
                                        {assessment.hasOwnProperty('nestedAssessments') ?
                                            <>
                                                <div className="library2Switch w-[20rem] sm:w-[40rem] sm:mt-2 lg:mt-10 lg:w-[57rem] 2xl:w-[76.5rem] mx-auto flex justify-center">
                                                    <Tabs
                                                        value={value2}
                                                        onChange={handleChange2}
                                                        aria-label="wrapped label tabs example"
                                                        TabIndicatorProps={{ style: { backgroundColor: "#333333" } }}
                                                        variant="scrollable"
                                                        scrollButtons
                                                        allowScrollButtonsMobile
                                                    >

                                                        {
                                                            assessment.nestedAssessments.map((nestedAssessment, innerIndex) =>
                                                                <Tab
                                                                    key={nestedAssessment.name}
                                                                    value={`inner${innerIndex}`}
                                                                    label={nestedAssessment.name}
                                                                    {...a11yProps(`inner${innerIndex}`)}
                                                                    sx={styles2}
                                                                    className=" 2xl:!text-[23px] !p-4 lg:!text-[15px]"
                                                                />
                                                            )
                                                        }
                                                    </Tabs>
                                                </div>

                                                <div className="panels w-[20rem] sm:w-[40rem] lg:w-[60rem] 2xl:w-[77rem] flex justify-center mt-10">
                                                    {
                                                        assessment.nestedAssessments.map((nestedAssessment, innerIndex) =>
                                                            <TabPanel key={`panelInner${assessment.name + indexNum}${innerIndex}`} value={value2} index={`inner${innerIndex}`}>
                                                                <AssessmentGrid collection={nestedAssessment.data} setIsOpen={setIsOpen} setModalData={setModalData} />
                                                            </TabPanel>
                                                        )
                                                    }
                                                </div>
                                            </>
                                            :
                                            <AssessmentGrid collection={assessment.data} setIsOpen={setIsOpen} setModalData={setModalData} />}
                                    </TabPanel>
                                )
                            }

                        </div>
                    </div>
                    {/* library ends */}

                    {/* page end start*/}
                    <div className="pageEnd">

                        <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '10rem', width: '100%' }}><path d="M-3.76,53.79 C161.02,147.54 334.84,150.50 500.00,49.99 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#F7F7F7' }} /></svg>
                    </div>
                    {/* page end */}

                </div>
            </div>
        </Layout>
    )
}

export default TestLibrary